import { SeminarCategory } from '~/gql/graphql';

const categoryLabels: Record<SeminarCategory, string> = {
  [SeminarCategory.FamilyBudgetImprovement]: '家計改善',
  [SeminarCategory.LifePlanning]: 'ライフプランニング',
  [SeminarCategory.EducationExpenses]: '教育資金',
  [SeminarCategory.Insurance]: '保険',
  [SeminarCategory.AssetManagement]: '資産運用/投資',
  [SeminarCategory.Mortgage]: '住宅ローン',
  [SeminarCategory.Retirement]: '老後資金',
  [SeminarCategory.Inheritance]: '相続',
  [SeminarCategory.Debt]: '借金返済/債務整理',
  [SeminarCategory.RealEstate]: '不動産',
  [SeminarCategory.SavingTax]: '節税',
} as const;

export const useSeminarCategories = () => {
  const toLabel = (cat: SeminarCategory) => categoryLabels[cat];
  return { toLabel };
};
